export default __webpack_public_path__ + "static/media/bg-pricing.b1a66687.jpeg";